<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    let { ftpAssetsUrl, dependsOn, label, imageUrl, css, values = $bindable() }: FieldComponentProps = $props()
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $state(true)

    $effect(() => {
        if (values && dependsOn) {
            displayComponent = ruleEngine.resolve(dependsOn, values)
        }
    })
</script>

{#if displayComponent}
    <img src="{ftpAssetsUrl}{imageUrl}" alt={label} class="image-input" style={css} loading="lazy" />
{/if}
